export default function FormatSortCode(e: any) {
  const newVal = e.computedValue.replace(/\D+/g, '')
  const blockVal = [newVal.slice(0, 2), newVal.slice(2, 4), newVal.slice(4, 6)].filter(x => x.length > 0).join('-')
  e.computedValue = blockVal
}
